



import {
  TextField,
  Box,
  IconButton,
  useTheme,
  MenuItem,
  Typography,
  Menu,
  Tooltip,
  Chip,
  LinearProgress,
  Checkbox,
  FormControlLabel,
  Button,
  Stack,
} from "@mui/material";
import { useEffect } from "react";
import DoneIcon from "@mui/icons-material/Done";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import Swal from "sweetalert2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RedoIcon from "@mui/icons-material/Redo";
import UndoIcon from "@mui/icons-material/Undo";
import BlockIcon from "@mui/icons-material/Block";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import LockResetIcon from "@mui/icons-material/LockReset";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
// import MatxCustomizer from "./Mailpdf";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import BalanceIcon from "@mui/icons-material/Balance";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { tokens, ColorModeContext } from "../../Theme";
import { useProSidebar } from "react-pro-sidebar";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { fetchListview, setEmployeeID, setFromDate, setToDate } from "../../store/reducers/Listviewapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Link } from "react-router-dom";
import { useContext } from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useState } from "react";
import { fnCsvFileUpload } from "../../store/reducers/Imguploadreducer";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { screenRightsData } from "../../store/reducers/screenRightsreducer";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import PauseCircleOutlinedIcon from "@mui/icons-material/PauseCircleOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import NotStartedOutlinedIcon from "@mui/icons-material/NotStartedOutlined";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import EmailIcon from "@mui/icons-material/Email";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../ui-components/global/utils";
import { fetchExplorelitview } from "../../store/reducers/Explorelitviewapireducer";
import { Employeeautocomplete } from "../../ui-components/global/Autocomplete";
import FlagIcon from "@mui/icons-material/Flag";
import AddTaskIcon from "@mui/icons-material/AddTask";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TodayIcon from "@mui/icons-material/Today";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import axios from "axios";
import { AttachFile } from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import QuizIcon from "@mui/icons-material/Quiz";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AnalyticsIcon from "@mui/icons-material/Analytics";
const Listview = () => {
  const navigate = useNavigate();
  const colorMode = useContext(ColorModeContext);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const YearFlag = sessionStorage.getItem("YearFlag");
  var currentPage = parseInt(sessionStorage.getItem("currentPage"));
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();

   const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");

  var accessID = params.accessID;
  console.log(accessID, "--passing accessID in listiew");
  
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [pageSize, setPageSize] = React.useState(20);
  const [page, setPage] = React.useState(currentPage || 0);
  const [collapse, setcollapse] = React.useState(false);
  var invoice;
  const mailData = useSelector((state) => state.listviewApi.mailData);
  const EMPID = sessionStorage.getItem("EmpId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const open = useSelector((state) => state.listviewApi.mailOpen);
  var screenName = params.screenName;
  console.log(screenName, "--screenName in kistvuhh");

   
  const year = sessionStorage.getItem("year");
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const loading = useSelector((state) => state.listviewApi.loading);
  const { UGA_ADD, UGA_VIEW, UGA_MOD, UGA_DEL, UGA_PROCESS, UGA_PRINT } =
    useSelector((state) => state.screenRights.data);
  const [errorMsgData, setErrorMsgData] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  const formatDateTime = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`
    );
  };

  const [empData, setempData] = useState(() => {
    const empId = sessionStorage.getItem("EmployeeID");
    const empName = sessionStorage.getItem("EmployeeName");

    // ✅ If UseCurrentEmp is Y → clear the field
    const isSelf = sessionStorage.getItem("UseCurrentEmp") === "Y";
    if (isSelf) return null;

    return empId && empName ? { RecordID: empId, Name: empName } : null;
  });

  const [useCurrentEmp, setUseCurrentEmp] = useState(() => {
    const storedSelf = sessionStorage.getItem("UseCurrentEmp");
    return storedSelf ? storedSelf === "Y" : false; // default false if not set
  });

const handleSelectionEmployeeChange = (newValue) => {
  if (newValue) {
    // ✅ store selected employee in state & session
    setempData(newValue);
    sessionStorage.setItem("SelectedEmployeeID", newValue.RecordID);
    sessionStorage.setItem("EmployeeName", newValue.Name);
    sessionStorage.setItem("UseCurrentEmp", "N"); // override self
  } else {
    // ✅ clear state & session if no value
    setempData(null);
    sessionStorage.removeItem("SelectedEmployeeID");
    sessionStorage.removeItem("EmployeeName");
  }

  setUseCurrentEmp(false);
};
 

  const listViewcolumn = useSelector((state) => state.listviewApi.columnData);
  const [selectedFile, setSelectedFile] = useState();
  const [uploadFile, setUploadFile] = useState();
  // const compID = sessionStorage.getItem("compID");
  const EmpId = sessionStorage.getItem("EmpId");

  const YearRecorid = sessionStorage.getItem("YearRecorid");
  const companyID = sessionStorage.getItem("companyId");
  const isManager = sessionStorage.getItem("isManager");
  const isprojectmanager = sessionStorage.getItem("isprojectmanager");

  // const handleApply = async () => {
  //   let employeeID = null;

  //   if (useCurrentEmp) {
  //     employeeID = EmpId; // From context or props
  //   } else if (empData?.RecordID) {
  //     employeeID = empData.RecordID;
  //   }

  //   if (employeeID) {
  //     const res = await dispatch(
  //       fetchListview(
  //         "TR264",
  //         "Onsite Activities",
  //         `EmployeeID='${employeeID}'`,
  //         ""
  //       )
  //     );
  //   } else {
  //     console.warn("No employee selected");
  //   }
  // };
  const handleApply = async () => {
    let employeeID = null;
    let employeeName = null;

    if (useCurrentEmp) {
      // ✅ Use logged-in EmpId but don't set any name in empData
      employeeID = EmpId;
      employeeName = null;
      setempData(null);         // clear field
    } else if (empData?.RecordID) {
      employeeID = empData.RecordID;
      employeeName = empData.Name;
    }

    if (employeeID) {
      // ✅ Store in session
      sessionStorage.setItem("EmployeeID", employeeID);
      sessionStorage.setItem("EmployeeName", employeeName || ""); // empty string when self
      sessionStorage.setItem("UseCurrentEmp", useCurrentEmp ? "Y" : "N");

      await dispatch(
        fetchListview(
          "TR264",
          "Onsite Activities",
          `EmployeeID='${employeeID}'`,
          ""
        )
      );
    } else {
      console.warn("No employee selected");
    }
  };


  const fromDate = useSelector((state) => state.listviewApi.fromDate);
  console.log("🚀 ~ Listview ~ fromDate:", fromDate)
  const toDate = useSelector((state) => state.listviewApi.toDate);
  const restoreempid = useSelector((state) => state.listviewApi.EmployeeID);
  const [selectedDate, setSelectedDate] = useState(toDate);
  const [fromselectedDate, setfromSelectedDate] = useState(fromDate);


  // React.useEffect(() => {
  //   if (accessID !== "TR277") {
  //     dispatch(
  //       fetchListview(
  //         accessID,
  //         screenName,
  //         accessID == "TR264" ? `EmployeeID='${EmpId}'` : "",
  //         "",
  //         companyID
  //         // "U"
  //       )
  //     );
  //   }
  //   const today = new Date();
  //   const formattedDate = today.toISOString().split("T")[0];
  //   setSelectedDate(formattedDate);
  //   setfromSelectedDate(formattedDate);
  //   // dispatch(screenRightsData(accessID));
  // }, [location.key]);
  React.useEffect(() => {
    // ✅ restore checkbox from session
    const storedSelf = sessionStorage.getItem("UseCurrentEmp");
    if (storedSelf !== null) {
      setUseCurrentEmp(storedSelf === "Y");
    }

    let filterCondition = "";

    if (accessID === "TR264") {
      const sessionEmpID = sessionStorage.getItem("SelectedEmployeeID");

      if (sessionEmpID) {
        filterCondition = `EmployeeID='${sessionEmpID}'`;
      } else {
        filterCondition = `EmployeeID='${EmpId}'`; // default
      }
    }

    if (accessID !== "TR277") {
      dispatch(
        fetchListview(
          accessID,
          screenName,
          filterCondition,
          "",
          companyID
        )
      );
    }

    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setSelectedDate(formattedDate);
    setfromSelectedDate(formattedDate);
  }, [location.key]);


  function filterByID(item) {
    if (item.hide !== true) {
      return true;
    }
  }

  // const columnShow = React.useMemo(
  //   () =>
  //     listViewcolumn.filter(filterByID)
  //       ? [
  //        {
  //               field: "slno",
  //               headerName: "SL#",
  //               width: 50,
  //               sortable: false,
  //               filterable: false,
  //               valueGetter: (params) =>
  //                 `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
  //             },
  //         ,
  //           ...listViewcolumn.filter(filterByID),
  //         ]
  //       :  [],
  //   [listViewcolumn]
  // );
  const columnShow = React.useMemo(
    () =>
      listViewcolumn.filter(filterByID)
        ? [
          {
            field: "slno",
            headerName: "SL#",
            width: 50,
            sortable: false,
            filterable: false,
            valueGetter: (params) =>
              page * pageSize +
              params.api.getRowIndexRelativeToVisibleRows(params.id) +
              1,
          },
          ...listViewcolumn.filter(filterByID),
        ]
        : [],
    [listViewcolumn, page, pageSize] // include page & pageSize as deps
  );
  const rows = React.useMemo(() => {
    return listViewData;
  }, [listViewData]);
  //   const [selectedEmp, setSelectedEmp] = useState({
  //     RecordID:sessionStorage.getItem("EmpId"),Name:sessionStorage.getItem("EmployeeName")
  //   });
  // console.log("SELECTEMPLOYEE",selectedEmp);
  // const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedEmp, setSelectedEmp] = useState(() => {
    const empId = sessionStorage.getItem("EmployeeID");
    const empName = sessionStorage.getItem("EmployeeName");
    return empId && empName ? { RecordID: empId, Name: empName } : null;
  });
  /*****************File upload************ */
  const changeHandler = async (event) => {
    setSelectedFile(event.target.files[0]);

    console.log(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "csv");

    const fileData = await dispatch(fnCsvFileUpload(formData));

    console.log("fileData" + JSON.stringify(fileData));
    setUploadFile(fileData.payload.apiResponse);
  };
  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR027/Employees");
        }
      } else {
        return;
      }
    });
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        key={location.key}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {broken && !rtl && (
          <IconButton
            sx={{ margin: "0 6 0 2" }}
            onClick={() => toggleSidebar()}
          >
            <MenuOutlinedIcon />
          </IconButton>
        )}
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h3">{screenName}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap", // allow wrapping on very small screens
            gap: 2,
            width: "100%",
            alignItems: "center",
          }}
        >
          {/* Left side fields */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap", // allows fields to stack on small screens
              gap: 2,
              marginBottom: 2,
              flex: "1 1 auto", // grow/shrink with container
              minWidth: 0, // prevent overflow
            }}
          >
            {accessID === "TR132" ? (
              <>
                {/* <TextField
                  name="fromdate"
                  type="date"
                  id="fromdate"
                  label="From Date"
                  variant="standard"
                  value={fromDate || ""} // Redux value
                  onChange={(e) => {
                    const newDate2 = e.target.value;
                    dispatch(setFromDate(newDate2)); // save in Redux

                    if (selectedDate) {
                      dispatch(
                        fetchListview(
                          "TR132",
                          "Scrum Task",
                          `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${newDate2}' AND '${toDate}'`,
                          ""
                        )
                      );
                    }
                  }}
                  focused
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    width: 250,
                    marginLeft: isManager != 1 ? "100px" : 0,
                  }}
                />

                <TextField
                  name="date"
                  type="date"
                  id="date"
                  label="To Date"
                  variant="standard"
                  value={toDate || ""} // Redux value
                  onChange={(e) => {
                    const newDate = e.target.value;
                    dispatch(setToDate(newDate)); // save in Redux

                    dispatch(
                      fetchListview(
                        "TR132",
                        "Scrum Task",
                        `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${newDate}'`,
                        ""
                      )
                    );
                  }}
                  focused
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    width: 250,
                    marginLeft: isManager != 1 ? "100px" : 0,
                  }}
                /> */}

                <TextField
                  name="fromdate"
                  type="date"
                  id="fromdate"
                  label="From Date"
                  variant="standard"
                  value={fromDate || ""}
                  onChange={(e) => {
                    const newDate2 = e.target.value;

                    // Save in Redux
                    dispatch(setFromDate(newDate2));

                    // Save in sessionStorage
                    sessionStorage.setItem("FromDate", newDate2);

                    if (selectedDate) {
                      dispatch(
                        fetchListview(
                          "TR132",
                          "Scrum Task",
                          `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${newDate2}' AND '${toDate}'`,
                          ""
                        )
                      );
                    }
                  }}
                  focused
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: new Date().toISOString().split("T")[0] }}
                  sx={{ width: 250, marginLeft: isManager != 1 ? "100px" : 0 }}
                />

                <TextField
                  name="date"
                  type="date"
                  id="date"
                  label="To Date"
                  variant="standard"
                  value={toDate || ""}
                  onChange={(e) => {
                    const newDate = e.target.value;

                    // Save in Redux
                    dispatch(setToDate(newDate));

                    // Save in sessionStorage
                    sessionStorage.setItem("ToDate", newDate);

                    dispatch(
                      fetchListview(
                        "TR132",
                        "Scrum Task",
                        `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${newDate}'`,
                        ""
                      )
                    );
                  }}
                  focused
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: new Date().toISOString().split("T")[0] }}
                  sx={{ width: 250, marginLeft: isManager != 1 ? "100px" : 0 }}
                />
              </>
            ) : (
              false
            )}

            {/* {isManager == 1 && accessID === "TR132" ? (
              <Employeeautocomplete
                sx={{
                  width: 250,
                  // marginLeft: isManager !== 1 ? "80px" : 0,

                  //  marginBottom: 1
                }}
                name="empName"
                label="Employee"
                id="empName"
                value={selectedEmp}
                
                onChange={(newValue) => {
                  if (newValue) {
                    setSelectedEmp(newValue);
                    const EmpId = newValue.RecordID;

                    // Save new EmpId in Redux
                    dispatch(setEmployeeID(EmpId));

                    // Save in sessionStorage
                    sessionStorage.setItem("EmployeeID", EmpId);
                    sessionStorage.setItem("EmployeeName", newValue.Name);

                    console.log(selectedDate, "--selectedDate");
                    console.log(newValue.Name, "--selected EmpName");

                    dispatch(
                      fetchListview(
                        "TR132",
                        "Scrum Task",
                        `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}'`,
                        ""
                      )
                    );
                  }
                }}

                url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
              />
            ) : null} */}
            {isManager == 1 && accessID === "TR132" ? (
              <Employeeautocomplete
                sx={{ width: 250 }}
                name="empName"
                label="Employee"
                id="empName"
                value={selectedEmp}   
                onChange={(newValue) => {
                  if (newValue) {
                    setSelectedEmp(newValue);
                    const EmpId = newValue.RecordID;

                    // Save in Redux
                    dispatch(setEmployeeID(EmpId));

                    // Save in sessionStorage
                    sessionStorage.setItem("EmployeeID", EmpId);
                    sessionStorage.setItem("EmployeeName", newValue.Name);

                    console.log(newValue.Name, "--selected EmpName");

                    // Fetch with new employee
                    dispatch(
                      fetchListview(
                        "TR132",
                        "Scrum Task",
                        `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}'`,
                        ""
                      )
                    );
                  } else {
                    // If cleared
                    setSelectedEmp(null);

                    // Remove from sessionStorage
                    sessionStorage.removeItem("EmployeeID");
                    sessionStorage.removeItem("EmployeeName");

                    // Reset Redux
                    dispatch(setEmployeeID(""));

                    console.log("Resetting to default EMPID");

                    // Fetch again with default EMPID
                    dispatch(
                      fetchListview(
                        "TR132",
                        "Scrum Task",
                        `EmployeesID='${EMPID}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}'`,
                        ""
                      )
                    );
                  }
                }}

                url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
              />
            ) : null}
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              flexShrink: 0, // prevent shrinking
              marginLeft: "auto", // push to right
            }}
          >
            <GridToolbarQuickFilter key={accessID} />

            {accessID == "TR002" ? (
              <Tooltip arrow title="Product Tracking">
                <AssessmentIcon
                  sx={{ marginTop: "10px" }}
                  color="primary"
                  onClick={() => {
                    navigate(
                      "/Apps/TR200/Editproducttracking/EditProduct Tracking/1/A"
                    );
                  }}
                />
              </Tooltip>
            ) : (
              false
            )}

            {accessID == "TR159" ||
              accessID == "TR216" ||
              accessID == "TR132" ||
              accessID == "TR219" ||
              accessID == "TR266" ||
              accessID == "TR242" ||
              accessID == "TR208" ||
              accessID == "TR160" ||
              accessID == "TR086" ||
              accessID == "TR271" ||
              (accessID === "TR133" &&
                isManager == 0 &&
                isprojectmanager == "Y") ? (
              <Tooltip arrow title="Add">
                <IconButton>
                  <AddOutlinedIcon
                    onClick={() => {
                      navigate(`./Edit${screenName}/-1/A`, {
                        state: {
                          CustomerID: "-1",
                          ProductID: "-1",
                          BomID: "-1",
                        },
                      });
                    }}
                  />
                </IconButton>
              </Tooltip>
            ) : (
              false
            )}

            {accessID == "TR043" ? (
              <Tooltip arrow title="Product Line Chart">
                <AssessmentIcon
                  sx={{ marginTop: "10px" }}
                  color="primary"
                  onClick={() => {
                    navigate(`/Apps/product-analysis/1/E`);
                  }}
                />
              </Tooltip>
            ) : (
              false
            )}

            {accessID == "TR064" ? (
              <Tooltip arrow title="Excel">
                <IconButton
                  size="large"
                  color="primary"
                  aria-label="upload picture"
                  component="label"
                >
                  <input
                    hidden
                    accept="all/*"
                    type="file"
                    onChange={changeHandler}
                  />
                  <FileUploadIcon />
                </IconButton>
              </Tooltip>
            ) : (
              false
            )}
            {accessID == "TR059" ? (
              <Tooltip arrow title="Report">
                <AssessmentIcon
                  sx={{ marginTop: "10px" }}
                  color="primary"
                  onClick={() => {
                    navigate("/Apps/TR100/Editreport/EditReport/1/A");
                  }}
                />
              </Tooltip>
            ) : (
              false
            )}

            <GridToolbarExport
              printOptions={{ disableToolbarButton: true }}
              csvOptions={{
                fileName: `${screenName}`,
              }}
            />

            <Tooltip arrow title="Logout">
              <IconButton onClick={() => fnLogOut("Logout")} color="error">
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {/* <GridToolbarQuickFilter key={accessID} />
          {accessID == "TR002" ? (
            <Tooltip arrow title="Product Tracking">
              <AssessmentIcon
                sx={{ marginTop: "10px" }}
                color="primary"
                onClick={() => {
                  navigate(
                    "/Apps/TR200/Editproducttracking/EditProduct Tracking/1/A"
                  );
                }}
              />
            </Tooltip>
          ) : (
            false
          )}

          {accessID == "TR159" ||
          accessID == "TR216" ||
          accessID == "TR132" ||
          accessID == "TR219" ||
          accessID == "TR266" ||
          accessID == "TR242" ||
          accessID == "TR208" ||
          accessID == "TR160" ||
          accessID == "TR086" ||
          accessID == "TR271" ||
          (accessID === "TR133" &&
            isManager == 0 &&
            isprojectmanager == "Y") ? (
            <Tooltip arrow title="Add">
              <IconButton>
                <AddOutlinedIcon
                  onClick={() => {
                    navigate(`./Edit${screenName}/-1/A`, {
                      state: {
                        CustomerID: "-1",
                        ProductID: "-1",
                        BomID: "-1",
                      },
                    });
                  }}
                />
              </IconButton>
            </Tooltip>
          ) : (
            false
          )}

          {accessID == "TR043" ? (
            <Tooltip arrow title="Product Line Chart">
              <AssessmentIcon
                sx={{ marginTop: "10px" }}
                color="primary"
                onClick={() => {
                  navigate(`/Apps/product-analysis/1/E`);
                }}
              />
            </Tooltip>
          ) : (
            false
          )}

          {accessID == "TR064" ? (
            <Tooltip arrow title="Excel">
              <IconButton
                size="large"
                color="primary"
                aria-label="upload picture"
                component="label"
              >
                <input
                  hidden
                  accept="all/*"
                  type="file"
                  onChange={changeHandler}
                />
                <FileUploadIcon />
              </IconButton>
            </Tooltip>
          ) : (
            false
          )}
          {accessID == "TR059" ? (
            <Tooltip arrow title="Report">
              <AssessmentIcon
                sx={{ marginTop: "10px" }}
                color="primary"
                onClick={() => {
                  navigate("/Apps/TR100/Editreport/EditReport/1/A");
                }}
              />
            </Tooltip>
          ) : (
            false
          )}

          <GridToolbarExport
            printOptions={{ disableToolbarButton: true }}
            csvOptions={{
              fileName: `${screenName}`,
            }}
          />

          <Tooltip arrow title="Logout">
            <IconButton onClick={() => fnLogOut("Logout")} color="error">
              <LogoutOutlinedIcon />
            </IconButton>
          </Tooltip> */}
        </Box>
      </GridToolbarContainer>
    );
  }

  const handlePagechange = (pageno) => {
    setPage(pageno);
    sessionStorage.setItem("currentPage", pageno);
  };

  return (
    <React.Fragment>
      <Box m="5px">
        <Box
          m="5px 0 0 0"
          padding={2}
          height={dataGridHeight}
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[800],
              // borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[800],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .odd-row": {
              backgroundColor: "",
              color: "", // Color for odd rows
            },
            "& .even-row": {
              backgroundColor: "#d0edec",
              color: "", // Color for even rows
            },
          }}
        >
          {accessID === "TR264" && (
            <Box
              display="grid"
              gridTemplateColumns="repeat(4 , minMax(0,1fr))"
              // gap="70px"
              gap={formGap}
              // padding={1}
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              <Employeeautocomplete
                name="Employee"
                label="Employee"
                id="Employee"
                value={empData}
                onChange={handleSelectionEmployeeChange}
                url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
              />
              <Box display="flex" alignItems="center">
                {/* <Checkbox
                  checked={useCurrentEmp}
                  onChange={(e) => {
                    setUseCurrentEmp(e.target.checked);
                    setempData(null);
                  }}
                  color="primary"
                  id="self-checkbox"
                /> */}
                <Checkbox
                  checked={useCurrentEmp}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setUseCurrentEmp(checked);

                    if (checked) {
                      setempData(null); // ✅ clear autocomplete
                      sessionStorage.setItem("UseCurrentEmp", "Y");
                      sessionStorage.setItem("EmployeeID", EmpId);
                      sessionStorage.setItem("EmployeeName", ""); // empty name
                    } else {
                      sessionStorage.setItem("UseCurrentEmp", "N");
                    }
                  }}
                  color="primary"
                  id="self-checkbox"
                />
                <label
                  htmlFor="self-checkbox"
                  style={{ marginLeft: 8, cursor: "default" }}
                >
                  Self
                </label>
              </Box>

              <Box
                gridColumn="span 2"
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                gap={2}
              // paddingTop={1}
              >
                <Button
                  onClick={handleApply}
                  variant="contained"
                  color="secondary"
                  size="small"
                >
                  APPLY
                </Button>

                {/* <Button
                  type="reset"
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => {
                    setempData(null);
                    setUseCurrentEmp(false);
                  }}
                >
                  RESET
                </Button> */}
                <Button
                  type="reset"
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => {
                    setempData(null);
                    setUseCurrentEmp(false);
                    sessionStorage.removeItem("EmployeeID");
                    sessionStorage.removeItem("EmployeeName");
                    sessionStorage.removeItem("UseCurrentEmp");
                  }}
                >
                  RESET
                </Button>



              </Box>
            </Box>
          )}

          <DataGrid
            sx={{
              "& .MuiDataGrid-footerContainer": {
                height: dataGridHeaderFooterHeight,
                minHeight: dataGridHeaderFooterHeight,
              },
            }}
            key={accessID}
            rows={rows}
            columns={columnShow}
            loading={loading}
            disableSelectionOnClick
            getRowId={(row) => row.RecordID}
            rowHeight={dataGridRowHeight}
            headerHeight={dataGridHeaderFooterHeight}
            pageSize={pageSize}
            page={page}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 15, 20]}
            onPageChange={(pageno) => handlePagechange(pageno)}
            components={{
              Toolbar: CustomToolbar,
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "odd-row"
                : "even-row"
            }
          />
        </Box>
        {accessID == "TR049" ? (
          <Box display="flex" flexDirection="row" padding="25px">
            <Chip
              icon={<ListAltOutlinedIcon color="primary" />}
              label="List of UOM"
              variant="outlined"
            />
          </Box>
        ) : accessID == "TR072" ? (
          <Box display="flex" flexDirection="row" padding="25px">
            <Chip
              icon={<ListAltOutlinedIcon color="primary" />}
              label="List Of Process"
              variant="outlined"
            />
          </Box>
        ) : //LIST OF ASSESSMENT
          accessID == "TR290" ? (
            <Box display="flex" flexDirection="row" padding="25px" gap={2}>
              <Chip
                icon={<FileUploadOutlinedIcon color="primary" />}
                label="Story Board"
                variant="outlined"
              />

              <Chip
                icon={<AccessTimeIcon color="primary" />}
                label="Session"
                variant="outlined"
              />
              {/* <Chip
              icon={<AssessmentIcon color="error" />}
              label="Start Assessment"
              variant="outlined"
            /> */}
              <Chip
                icon={<QuizIcon color="error" />}
                label="Start Assessment"
                variant="outlined"
              />
              {/* <Chip
              icon={<DashboardIcon color="error" />}
              label="View Dashboard"
              variant="outlined"
            /> */}
              <Chip
                icon={<AnalyticsIcon color="secondary" />}
                label="View Scoreboard"
                variant="outlined"
              />
            </Box>
          ) : //Scrum Task
            accessID == "TR132" ? (
              <Box
                display="flex"
                flexDirection="row"
                gap={1}
                padding="25px"
                sx={{ overflowY: "auto" }}
              >
                <Chip
                  icon={<ModeEditOutlinedIcon color="primary" />}
                  label="Edit"
                  variant="outlined"
                />

                <Chip
                  icon={<VisibilityIcon color="primary" />}
                  label="View"
                  variant="outlined"
                />

                <Chip
                  icon={<AssignmentTurnedInIcon color="success" />}
                  label="Completed"
                  variant="outlined"
                />

                {/* <Chip
                icon={<EscalatorWarningIcon color="primary" />}
                label="Dependency"
                variant="outlined"
              /> */}
                <Chip
                  icon={<RedoIcon color="primary" />}
                  label="Transfer In"
                  variant="outlined"
                />
                <Chip
                  icon={<UndoIcon color="warning" />}
                  label="Transfer Out"
                  variant="outlined"
                />
                <Chip
                  icon={<BlockIcon color="primary" />}
                  label="Blocked"
                  variant="outlined"
                />
                <Chip
                  icon={<DoneOutlineIcon color="primary" />}
                  label="Pick Now"
                  variant="outlined"
                />
                <Chip
                  icon={<LockResetIcon color="primary" />}
                  label="Unblocked"
                  variant="outlined"
                />
                <Chip
                  icon={<AttachFileIcon color="primary" />}
                  label="Attachment"
                  variant="outlined"
                />
              </Box>
            ) : accessID == "TR266" ? (
              <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                <Chip
                  icon={<ModeEditOutlinedIcon color="primary" />}
                  label="Edit"
                  variant="outlined"
                />
                <Chip
                  icon={<AttachFileIcon color="primary" />}
                  label="Attachment"
                  variant="outlined"
                />
              </Box>
            ) : accessID == "TR208" ? (
              <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                <Chip
                  icon={<ModeEditOutlinedIcon color="primary" />}
                  label="Edit"
                  variant="outlined"
                />
                <Chip
                  icon={<AttachFileIcon color="primary" />}
                  label="Attachment"
                  variant="outlined"
                />
              </Box>
            ) : accessID == "TR160" ? (
              <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                <Chip
                  icon={<ModeEditOutlinedIcon color="primary" />}
                  label="Edit"
                  variant="outlined"
                />
                <Chip
                  icon={<AttachFileIcon color="primary" />}
                  label="Attachment"
                  variant="outlined"
                />
              </Box>
            ) : accessID == "TR242" ? (
              <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                <Chip
                  icon={<ModeEditOutlinedIcon color="primary" />}
                  label="Edit"
                  variant="outlined"
                />
                <Chip
                  icon={<AttachFileIcon color="primary" />}
                  label="Attachment"
                  variant="outlined"
                />
              </Box>
            ) : accessID == "TR216" ? (
              <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                <Chip
                  icon={<ModeEditOutlinedIcon color="primary" />}
                  label="Edit"
                  variant="outlined"
                />
                <Chip
                  icon={<AttachFileIcon color="primary" />}
                  label="Attachment"
                  variant="outlined"
                />
              </Box>
            ) : accessID == "TR219" ? (
              <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                <Chip
                  icon={<ModeEditOutlinedIcon color="primary" />}
                  label="Edit"
                  variant="outlined"
                />
                <Chip
                  icon={<AttachFileIcon color="primary" />}
                  label="Attachment"
                  variant="outlined"
                />
              </Box>
            ) : // accessID == "TR245" ? (
              //   <Box
              //     display="flex"
              //     flexDirection="row"
              //     gap={1}
              //     padding="25px"
              //     sx={{ overflowY: "auto" }}
              //   >
              //     <Chip
              //       icon={<ListAltOutlinedIcon color="primary" />}
              //       label="Leave"
              //       variant="outlined"
              //     />
              //     <Chip
              //       icon={<ListAltOutlinedIcon color="primary" />}
              //       label="Onduty"
              //       variant="outlined"
              //     />
              //     <Chip
              //       icon={<ListAltOutlinedIcon color="primary" />}
              //       label="Overtime"
              //       variant="outlined"
              //     />
              //      <Chip
              //       icon={<ContactSupportIcon color="primary" />}
              //       label="Overtime"
              //       variant="outlined"
              //     />
              //     <Chip
              //       icon={<ListAltOutlinedIcon color="primary" />}
              //       label="Employee"
              //       variant="outlined"
              //     />
              //   </Box>
              accessID == "TR058" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Remarks"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR010" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  sx={{ overflowY: "auto" }}
                >
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<WysiwygIcon color="primary" />}
                    label="Customer Products"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<AssessmentIcon color="primary" />}
                    label="Customer Analysis"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<AddPhotoAlternateIcon color="primary" />}
                    label="Image Upload"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR009" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<EditIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<AddPhotoAlternateIcon color="primary" />}
                    label="Image Upload"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR264" ? (
                <Box display="flex" flexDirection="row" padding="15px" marginTop={2}>
                  <Chip
                    icon={<DoneIcon color="primary" />}
                    label="Approve"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ContactSupportIcon color="primary" />}
                    label="Query"
                    variant="outlined"
                    sx={{ marginLeft: "20px" }}
                  />
                  <Chip
                    icon={<VisibilityIcon color="primary" />}
                    label="View"
                    variant="outlined"
                    sx={{ marginLeft: "20px" }}
                  />
                </Box>
              ) : accessID == "TR083" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Colors"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR002" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Products"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<AddPhotoAlternateIcon color="primary" />}
                    label="Image Upload"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR044" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label=" List of Category"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR064" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Stock"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR059" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Delivery Challan"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR078" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR047" ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  padding="25px"
                  sx={{ overflowY: "auto" }}
                >
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Production Card Items"
                    variant="outlined"
                  />
                  <Chip
                    icon={<ListAltOutlinedIcon color="error" />}
                    label="Indent Items"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="primary" />}
                    label="Print"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<SettingsBackupRestoreIcon color="primary" />}
                    label="Process"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<EmailIcon color="primary" />}
                    label="Email"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<PlayCircleOutlineOutlinedIcon color="success" />}
                    label="Not yet Started"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<NotStartedOutlinedIcon color="primary" />}
                    label="Inprogress"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<TaskAltOutlinedIcon color="success" />}
                    label="Completed"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<PauseCircleOutlinedIcon color="warning" />}
                    label="Pause"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR076" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Batch"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR116" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Packing List"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR109" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<PrintOutlinedIcon color="primary" />}
                    label="Print"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                  <Chip
                    icon={<EmailIcon color="primary" />}
                    label="Email"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR043" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Invoice"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR101" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="Order Enquiry"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR027" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />

                  <Chip
                    icon={<AddPhotoAlternateIcon color="primary" />}
                    label="Image Upload"
                    variant="outlined"
                    sx={{ marginLeft: "50px" }}
                  />
                </Box>
              ) : accessID == "TR133" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                  <Chip
                    icon={<BalanceIcon color="primary" />}
                    label="Milestone Weightage"
                    variant="outlined"
                  />
                  {/* <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            /> */}
                  <Chip
                    icon={<FlagIcon color="primary" />}
                    label="List of Milestone"
                    variant="outlined"
                  />
                  {/* <Chip
              icon={<TaskAltIcon  color="primary" />}
              label="Sprint"
              variant="outlined"
            /> */}
                  <Chip
                    icon={<PeopleAltIcon color="primary" />}
                    label="Team Project"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR269" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                  {/* <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            />
            */}
                  <Chip
                    icon={<TaskAltIcon color="primary" />}
                    label="Sprint"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR276" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />

                  <Chip
                    icon={<TransferWithinAStationIcon color="primary" />}
                    label="Routine Tasks"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR123" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                  <Chip
                    icon={<ModeEditOutlinedIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                  <Chip
                    icon={<TodayIcon color="primary" />}
                    label="Scrum Task"
                    variant="outlined"
                  />
                </Box>
              ) : accessID == "TR099" ? (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<ListAltOutlinedIcon color="primary" />}
                    label="List of Usergroups"
                    variant="outlined"
                  />
                </Box>
              ) : (
                <Box display="flex" flexDirection="row" padding="25px">
                  <Chip
                    icon={<EditIcon color="primary" />}
                    label="Edit"
                    variant="outlined"
                  />
                </Box>
              )}
      </Box>
      {/* <MatxCustomizer open={open}screenName={invoice} rowData={mailData} type={""} /> */}
    </React.Fragment>
  );
};
export default Listview;